import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Components/Button';

import './ShowAllPreparationsButton.scss';

export default function ShowAllPreparationsButton(props) {
  const { isSubstancesContext, supportsReactions, showAllPreparations } = props;

  if (!isSubstancesContext || !supportsReactions) {
    return null;
  }

  return (
    <Button
      id="showAllPreparations"
      title="Show all Preparations with Substance as a Product"
      onClick={() => {
        showAllPreparations();
      }}
      buttonConfig={{
        className: 'result-toolbar-show-all-preparations-button',
        label: 'Preparations',
        type: 'link',
        size: 'tiny',
        e2eName: 'export-preparations',
      }}
      iconConfig={{
        position: 'before',
        name: 'preparations',
        size: 'sm',
      }}
    />
  );
}

ShowAllPreparationsButton.defaultProps = {
  showAllPreparations: () => {
    Logger.error('showAllPreparations something went wrong, value from ng is not a function');
  },
};

ShowAllPreparationsButton.propTypes = {
  supportsReactions: PropTypes.bool,
  showAllPreparations: PropTypes.func,
  isSubstancesContext: PropTypes.bool.isRequired,
};
